import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCard, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { trackClick } from '../utils/analytics';

const ACORN_URL = 'https://your.acornfinance.com/calculator?d=U47VA&utm_source=mobile-app-copy';

export const FinancingCTA = ({ sourcePage = 'service_page' }) => {
  const handleClick = () => {
    trackClick('financing_cta_click', sourcePage);
    trackClick(`financing_from_service_page`, sourcePage);
    window.open(ACORN_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="py-12 bg-zinc-900" data-testid="financing-cta-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10">
          <div className="w-14 h-14 bg-red-600 rounded-xl flex items-center justify-center shrink-0">
            <CreditCard size={28} className="text-white" />
          </div>
          <div className="flex-1 text-center md:text-left">
            <h3 className="text-xl font-bold text-white mb-1">Financing Available</h3>
            <p className="text-zinc-400 text-sm">
              Build the project your property needs. Explore financing options through our financing partner.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <Button
              onClick={handleClick}
              className="bg-red-600 hover:bg-red-700 text-white font-bold px-6"
              data-testid="financing-cta-acorn"
            >
              CHECK FINANCING OPTIONS <ArrowRight size={16} className="ml-2" />
            </Button>
            <Link to="/financing">
              <Button variant="outline" className="border-zinc-600 text-zinc-300 hover:bg-white hover:text-black font-bold px-6 w-full" data-testid="financing-cta-learn">
                Learn More
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
